// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  IDocumentProofGetAllAttrs,
  IDocumentProofGetAttrs,
  IDocumentProofSaveAttrs,
  IDocumentProofGetDropdownAttrs,
} from 'interfaces/back-office/master/document-proof/document-proof-view.interface'

const useMasterDocumentProof = () => {
  // Hook
  const {
    masterDocumentProof: {
      masterDocumentProof_isLoading,
      masterDocumentProof_isSaveLoading,
      masterDocumentProof_documentProofs,
      masterDocumentProof_detail,
      masterDocumentProof_dropdown,
      masterDocumentProof_CLEAR_DOCUMENT_PROOFS,
      masterDocumentProof_CLEAR_DOCUMENT_PROOF,
      masterDocumentProof_CLEAR_DOCUMENT_PROOF_DROPDOWN,
      masterDocumentProof_fetchDocumentProofs: masterDocumentProofFetchList,
      masterDocumentProof_fetchDocumentProof: masterDocumentProofFetch,
      masterDocumentProof_saveDocumentProof: masterDocumentProofSave,
      masterDocumentProof_fetchDocumentProofDropdown: masterDocumentProofFetchDropdown,
    },
  } = useStores()

  /**
   * @description Fetch document proof list
   *
   * @param {IDocumentProofGetAllAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterDocumentProof_fetchDocumentProofs = useCallback(
    (payload: IDocumentProofGetAllAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        masterDocumentProofFetchList({
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Fetch document proof
   *
   * @param {IDocumentProofGetAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterDocumentProof_fetchDocumentProof = useCallback(
    (payload: IDocumentProofGetAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        masterDocumentProofFetch({
          params: payload.params,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Save document detail
   *
   * @param {IDocumentProofSaveAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterDocumentProof_saveDocumentProof = useCallback(
    (payload: IDocumentProofSaveAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        masterDocumentProofSave({
          params: payload.params,
          body: payload.body,
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  /**
   * @description Fetch dropdown
   *
   * @param {IDocumentProofGetDropdownAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const masterDocumentProof_fetchDocumentProofDropdown = useCallback(
    (payload: IDocumentProofGetDropdownAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        masterDocumentProofFetchDropdown({
          requestConfig: payload.requestConfig,
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    // eslint-disable-next-line
    [],
  )

  return {
    masterDocumentProof_isLoading,
    masterDocumentProof_isSaveLoading,
    masterDocumentProof_documentProofs,
    masterDocumentProof_detail,
    masterDocumentProof_dropdown,
    masterDocumentProof_CLEAR_DOCUMENT_PROOFS,
    masterDocumentProof_CLEAR_DOCUMENT_PROOF,
    masterDocumentProof_CLEAR_DOCUMENT_PROOF_DROPDOWN,
    masterDocumentProof_fetchDocumentProofs,
    masterDocumentProof_fetchDocumentProof,
    masterDocumentProof_saveDocumentProof,
    masterDocumentProof_fetchDocumentProofDropdown,
  }
}

export { useMasterDocumentProof }
